/**
 * Labstep
 *
 * @module components/FilterPost/Report/Entity
 * @desc Filter to toggle between deleted items
 */

import { FilterPostReportEntityForm } from 'labstep-web/components/FilterPost/Report/Entity/Form';
import { ICONS } from 'labstep-web/constants/icons';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { ModalDefaultContainer as Modal } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import type { FilterPostReportEntityProps } from './types';

export const FilterPostReportEntity: React.FC<
  FilterPostReportEntityProps
> = ({
  label,
  path,
  field,
  addPostFilter,
  defaultValues,
  entityName,
  protocolValueName,
  ...rest
}) => (
  <Modal
    header={`Filter by ${label}`}
    viewComponent={({ toggleModal }): React.ReactNode => (
      <ActionComponent
        onClick={toggleModal}
        type="option"
        icon={ICONS.metadata.secondary}
        text="Filter by this field"
        dataCy={`components/FilterPost/Report/Entity:${entityName}`}
      />
    )}
    content={({ toggleModal }): React.ReactNode => (
      <FilterPostReportEntityForm
        addPostFilter={addPostFilter}
        path={path}
        field={field}
        defaultValues={defaultValues}
        onDone={toggleModal}
        entityName={entityName}
        protocolValueName={protocolValueName}
      />
    )}
    {...rest}
  />
);
